module.exports = __webpack_public_path__ + "assets/img/exam_cbt_2025_ttlSP.5df18a1c.svg";